<template>
  <keep-alive v-if="asthmaNodeComponent">
    <component :is="asthmaNodeComponent" :content="content" v-bind="nodeData" />
  </keep-alive>
  <div v-else>asthma form node not found</div>
</template>

<script>
import { Component } from 'vue'
import { PropsDefinition, Computed } from '@/_typedefs'
import { FormNodeProps } from '../../FormNodes/FormNode.vue'
import ConductNodeVue from './Conduct/ConductNode.vue'
import ReportNodeVue from './Report/ReportNode.vue'

/**
 * @typedef {Object} AsthmaFormNodeProps
 * @property {string} kind
 * @property {object} nodeData
 * @property {FormNodeProps | FormNodeProps[]} content
 */

export default {
  name: 'AsthmaFormNode',
  /** @type {PropsDefinition<AsthmaFormNodeProps>} */
  props: {
    kind: {
      type: String,
      required: true,
    },
    nodeData: {
      type: Object,
      default: () => ({}),
    },
    content: {
      type: [Array, Object],
      default: null,
    },
  },
  computed: {
    /** @type {Computed<Component?>} */
    asthmaNodeComponent() {
      if (this.kind.match(/:/g)?.length ?? 0 >= 2) {
      }

      const nodeMap = {
        'asthma:conduct': ConductNodeVue,
        'asthma:conduct-warning': ConductNodeVue,
        'asthma:report': ReportNodeVue,
      }

      return nodeMap[this.kind] ?? null
    },
  },
}
</script>

<style></style>
